module.exports = __webpack_public_path__ + "static/media/verifyEmail.33975944.svg";